module.exports = __webpack_public_path__ + "img/image53.e5b525dc.png";